import React from 'react';
import PropTypes from 'prop-types';
// Assets
import BrushCaret from '../../assets/brush/brush-caret.png';
// Components
import { Container } from '../styled/containers';
import { propLink } from '../link-handler';
import CTA from '../cta';
// Styles
import {
  AddMargin,
  BodyText,
  BrushElement,
  CTAWrapper,
  CallToActionText,
  ContentContainer,
  Header,
  Wrapper,
} from './styles';

const CTASection = ({ callToActionText, callToActionButton }) => (
  <CTAWrapper>
    <ContentContainer>
      <CallToActionText>
        <strong>{callToActionText}</strong>
      </CallToActionText>
      <CTA bg="primary" link={callToActionButton.link}>
        {callToActionButton.buttonText}
      </CTA>
    </ContentContainer>
  </CTAWrapper>
);

CTASection.propTypes = {
  callToActionText: PropTypes.string.isRequired,
  callToActionButton: PropTypes.shape({
    buttonText: PropTypes.string.isRequired,
    link: propLink.isRequired,
  }),
};

const BylineBanner = ({
  bylineTitle,
  bylineBodyText,
  removeMarginBottom,
  callToActionText,
  callToActionButton,
  decorated = false,
  ctaOnly = false,
}) => {
  if (ctaOnly && callToActionText && callToActionButton) {
    return (
      <CTASection
        callToActionText={callToActionText}
        callToActionButton={callToActionButton}
      />
    );
  }

  const showCallToAction = callToActionText && callToActionButton;
  return (
    <AddMargin $removeMarginBottom={removeMarginBottom}>
      <Wrapper $decorated={decorated}>
        <Container>
          {decorated ? <BrushElement src={BrushCaret} alt="" /> : null}
          {bylineTitle ? (
            <Header $decorated={decorated}>{bylineTitle}</Header>
          ) : null}
          {decorated && bylineBodyText ? (
            <BodyText>{bylineBodyText}</BodyText>
          ) : null}
        </Container>
      </Wrapper>

      {showCallToAction ? (
        <CTASection
          callToActionText={callToActionText}
          callToActionButton={callToActionButton}
        />
      ) : null}
    </AddMargin>
  );
};

BylineBanner.propTypes = {
  bylineTitle: PropTypes.string,
  bylineBodyText: PropTypes.string,
  decorated: PropTypes.bool,
  removeMarginBottom: PropTypes.bool,
  ctaOnly: PropTypes.bool,
  callToActionText: PropTypes.string.isRequired,
  callToActionButton: PropTypes.shape({
    buttonText: PropTypes.string.isRequired,
    link: propLink.isRequired,
  }),
};

BylineBanner.defaultProps = {
  removeMarginBottom: true,
  decorated: false,
  ctaOnly: false,
};

export default BylineBanner;

export const BylineBannerAssembly = ({ contentfulData }) => (
  <BylineBanner
    bylineTitle={contentfulData.bylineTitle}
    bylineBodyText={contentfulData.bylineBodyText}
    removeMarginBottom={contentfulData.removeMarginBottom}
    decorated={contentfulData.decorated}
    callToActionText={contentfulData.callToActionText}
    callToActionButton={contentfulData.callToActionButton}
  />
);

BylineBannerAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
